import React from 'react';
import './RunnerCv.css';
import './CoverLetter.css';

// Unlinked page: reachable only by typing the URL directly. Kept free of the
// site header and footer so it prints as a standalone A4 letter.
const CoverLetter = () => {
  return (
    <div className="runner-cv-page">
      <article className="runner-cv cover-letter">
        <header className="cover-letter__header">
          <h1 className="runner-cv__name">Sean Derham</h1>
          <p className="runner-cv__role">Production Runner</p>
          <div className="runner-cv__contacts">
            <a href="tel:+447597368482">07597 368482</a>
            <a href="mailto:sjderham@protonmail.com">sjderham@protonmail.com</a>
            <a
              href="https://seanderham.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              seanderham.com
            </a>
          </div>
        </header>

        <p className="cover-letter__meta">
          Application: Studio Production Assistant · MOO Creative, London
        </p>

        <div className="cover-letter__body">
          <p>Dear MOO Creative team,</p>

          <p>
            I&apos;d like to apply for the Studio Production Assistant role in
            your London office. For the last four years I&apos;ve worked as a
            motion designer and videographer, and a lot of that time has gone
            into what this role describes: getting the studio and kit ready so
            shoot days run smoothly.
          </p>

          <p>
            At Box Bear I looked after the in-house studio, prepping the camera
            and lighting kit before shoots and running the audio for live
            sessions with healthcare professionals joining from around the
            world. I was also responsible for keeping media organised and
            versioned on every project through to final export. More recently at
            Truth Creative I led small-crew shoots at client sites around the
            UK. With a small crew there&apos;s nobody else to call when
            something plays up, so I&apos;m used to sorting problems out on the
            spot.
          </p>

          <p>
            Outside work I shoot and edit my own short films on a Sony FX3,
            which is where I get to try out lighting and camera shots away from
            a client brief. I&apos;d really enjoy learning how your Lead
            Photographer approaches shoots and take some of that back into my
            own films.
          </p>

          <p>
            Away from cameras, I spent three summers at Wimbledon running the
            media bar and restaurant for press and players. Keeping stock
            organised and a busy space ready for the next session has a lot in
            common with looking after a studio, and it&apos;s work I take pride
            in.
          </p>

          <p>
            Post-production is where most of my experience sits. I edit in
            Premiere Pro and DaVinci Resolve and build motion graphics in After
            Effects, so I&apos;d be glad to help once a shoot wraps as well as
            during it.
          </p>

          <p>
            I&apos;m based in London and can start straight away. My CV is
            attached and there&apos;s more of my work at{' '}
            <a
              href="https://seanderham.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              seanderham.com
            </a>
            . I&apos;d love to chat about the role, and I&apos;m happy to be
            measured for the matching jacket.
          </p>

          <p className="cover-letter__signoff">
            Kind regards,
            <br />
            Sean Derham
            <br />
            07597 368482
            <br />
            sjderham@protonmail.com
          </p>
        </div>
      </article>
    </div>
  );
};

export default CoverLetter;
